import { render, staticRenderFns } from "./JobStatusRelation.vue?vue&type=template&id=aea0d9d0&"
import script from "./JobStatusRelation.vue?vue&type=script&lang=js&"
export * from "./JobStatusRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports